export function passageUrl(pageUrl: string, revisionId: string | undefined, nodeId?: string): string {
  const url = new URL(pageUrl);
  url.search = "";
  url.hash = nodeId ? `node-${nodeId}` : "";
  if (revisionId) url.searchParams.set("revision", revisionId);
  return url.toString();
}

export function initializeReaderTools(root: Document = document) {
  root.addEventListener("click", async event => {
    const target = event.target as Element | null;
    const contentsLink = target?.closest<HTMLAnchorElement>(".page-contents a");
    if (contentsLink) contentsLink.closest<HTMLDetailsElement>("details")!.open = false;
    const moreAction = target?.closest(".document-more-tools button, .document-more-tools a");
    if (moreAction) moreAction.closest<HTMLDetailsElement>("details")!.open = false;
    const copy = target?.closest<HTMLButtonElement>("[data-copy-page-link]");
    if (!copy) return;
    const reader = root.querySelector<HTMLElement>("[data-qprins-static-document]");
    if (!reader) return;
    const revision = copy.dataset.copyPageLink === "revision" ? reader.dataset.revisionId : undefined;
    const value = passageUrl(location.href, revision);
    try {
      await navigator.clipboard.writeText(value);
      const label = copy.textContent;
      copy.textContent = "Copied";
      window.setTimeout(() => { if (copy.isConnected) copy.textContent = label; }, 1600);
    } catch {
      window.prompt("Copy this link", value);
    }
  });
  root.addEventListener("keydown", event => {
    if (event.key !== "Escape") return;
    root.querySelectorAll<HTMLDetailsElement>(".page-contents[open], .document-more-tools[open]")
      .forEach(details => { details.open = false; details.querySelector<HTMLElement>("summary")?.focus(); });
  });
}
